import React, { useContext, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext, BadgesContext } from '../App';
import api from '../utils/api';
import Modal from './Modal';
import { LEAD_SOURCES } from '../utils/sources';
import HabitsWidget from './HabitsWidget';
import QuickInquiry from './QuickInquiry';
import GlobalSearch from './GlobalSearch';

const Icon = ({ d, size = 16, stroke = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke={stroke} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    {Array.isArray(d) ? d.map((seg, i) => <path key={i} d={seg} />) : <path d={d} />}
  </svg>
);

const ICONS = {
  clients:   ['M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2', 'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z', 'M23 21v-2a4 4 0 0 0-3-3.87', 'M16 3.13a4 4 0 0 1 0 7.75'],
  mfc:       'M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z',
  court:     ['M12 2L2 7l10 5 10-5-10-5z', 'M2 17l10 5 10-5', 'M2 12l10 5 10-5'],
  pause:     ['M10 4H6v16h4V4z', 'M18 4h-4v16h4V4z'],
  unknown:   ['M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3', 'M12 17h.01'],
  analysis:  ['M12 20V10', 'M18 20V4', 'M6 20v-4'],
  thinking:  ['M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z', 'M12 6v6l4 2'],
  noshow:    ['M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2', 'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z', 'M23 18l-5-5', 'M18 18l5-5'],
  tasks:     ['M9 11l3 3L22 4', 'M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11'],
  payments:  ['M2 17l.621 2.485A1 1 0 0 0 3.591 20H20.41a1 1 0 0 0 .97-.515L22 17', 'M6.5 12h11', 'M12 7v10'],
  analytics: ['M18 20V10', 'M12 20V4', 'M6 20v-6'],
  wallet:    ['M21 12V7H5a2 2 0 0 1 0-4h14v4', 'M3 5v14a2 2 0 0 0 2 2h16v-5', 'M18 12a2 2 0 0 0 0 4h4v-4z'],
  creditors: ['M4 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7z', 'M16 3v4', 'M8 3v4', 'M4 11h16'],
  referrals: ['M17 20h5v-1a3 3 0 0 0-5.356-1.857', 'M9 20H4v-1a3 3 0 0 1 5.356-1.857', 'M15 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0z', 'M21 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0z', 'M7 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0z'],
  legal:     ['M4 19.5A2.5 2.5 0 0 1 6.5 17H20', 'M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z', 'M9 7h7', 'M9 11h7'],
  contacts:  ['M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z'],
  judges:    ['M12 3v18', 'M5 21h14', 'M4 8h16', 'M7 8l-3 6a3 3 0 0 0 6 0z', 'M17 8l-3 6a3 3 0 0 0 6 0z'],
  useful:    ['M4 19.5A2.5 2.5 0 0 1 6.5 17H20', 'M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z'],
  assistant: ['M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20z', 'M12 16v-4', 'M12 8h.01'],
  personal:  ['M20 21v-2a4 4 0 0 0-4-4h-4a4 4 0 0 0-4 4v2', 'M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z', 'M16 3.13a4 4 0 0 1 0 7.75'],
  roadmap:   ['M22 12h-4l-3 9L9 3l-3 9H2'],
  backup:    ['M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4', 'M7 10l5 5 5-5', 'M12 15V3'],
  content:   ['M12 20h9', 'M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z'],
  marketing: ['M3 11l18-5v12L3 14v-3z', 'M11.6 16.8a3 3 0 1 1-5.8-1.6'],
  remote:    ['M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2', 'M23 21v-2a4 4 0 0 0-3-3.87', 'M16 3.13a4 4 0 0 1 0 7.75', 'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z'],
  mfcservice: ['M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z', 'M9 22V12h6v10'],
  cases:     ['M20 7H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z', 'M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16'],
  hearings:  ['M12 3v18', 'M5 21h14', 'M6 7h12', 'M6 7l-3 7a3 3 0 0 0 6 0z', 'M18 7l-3 7a3 3 0 0 0 6 0z'],
  logout:    ['M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4', 'M16 17l5-5-5-5', 'M21 12H9'],
};

// Банкротство: две основные строки + компактные фильтры (24.09.2026 — меню стало короче)
const CLIENT_MAIN = [
  { path: '/clients',       label: 'МФЦ-банкротство', icon: 'mfc',  exact: true },
  { path: '/clients-court', label: 'Судебное',        icon: 'court' },
];
const CLIENT_FILTERS = [
  { path: '/clients-unknown',  label: 'Не определён' },
  { path: '/clients-analysis', label: 'Анализ' },
  { path: '/clients-thinking', label: 'Думает' },
  { path: '/clients-noshow',   label: 'Не явились' },
  { path: '/clients-paused',   label: 'Пауза' },
];

// Группы меню. collapsible — сворачивается кликом по заголовку, состояние запоминается в браузере.
const DESK = {
  key: 'desk', label: 'Рабочий стол',
  items: [
    { path: '/tasks',     icon: 'tasks',     label: 'Задачи',    badgeKey: 'tasks' },
    { path: '/payments',  icon: 'payments',  label: 'Рассрочки', badgeKey: 'payments' },
    { path: '/inquiries', icon: 'contacts',  label: 'Обращения' },
    { path: '/marketing', icon: 'marketing', label: 'Реклама' },
    { path: '/trades',    icon: 'payments',  label: 'Торги — беру' },   // 26.10.2026: лоты «Берём» с dz.ucfemida.ru
  ],
};
const GROUPS = [
  {
    key: 'civil', label: 'Гражданские дела', defaultOpen: true,
    items: [
      { path: '/cases',           icon: 'cases',     label: 'Все дела', exact: true },
      { path: '/hearings',        icon: 'hearings',  label: 'Заседания' },
      { path: '/cases-analytics', icon: 'analytics', label: 'Аналитика дел' },
    ],
  },
  {
    key: 'mfc', label: 'МФЦ-сервис', defaultOpen: false,
    items: [
      { path: '/mfc-service', icon: 'mfcservice', label: 'Клиенты сервиса', badgeKey: 'mfcUnread' },
      { path: '/mfc-analytics', icon: 'mfcservice', label: 'Аналитика МФЦ' },
    ],
  },
  {
    key: 'refs', label: 'Справочники', defaultOpen: false,
    items: [
      { path: '/creditor-db', icon: 'creditors', label: 'База кредиторов' },
      { path: '/legal-docs',  icon: 'legal',     label: 'Правовая база' },
      { path: '/referrals',   icon: 'referrals', label: 'Рефералы' },
    ],
  },
  {
    key: 'other', label: 'Прочее', defaultOpen: false,
    items: [
      { path: '/analytics',      icon: 'analytics', label: 'Аналитика' },
      { path: '/finance',        icon: 'wallet',    label: 'Мои финансы' },
      { path: '/roadmap',        icon: 'roadmap',   label: 'Развитие' },
      { path: '/personal-tasks', icon: 'personal',  label: 'Личные задачи' },
      { path: '/useful',         icon: 'useful',    label: 'Полезное' },
      { path: '/shop-orders',    icon: 'payments',  label: 'Продажи с сайта' },
      { path: '/backup',         icon: 'backup',    label: 'Бэкап' },
    ],
  },
  {
    // 11.10.2026: разделы, которые открываются реже раза в неделю — убраны из основных групп, чтобы меню было короче
    key: 'rare', label: 'Редко нужные', defaultOpen: false,
    items: [
      { path: '/judges',         icon: 'judges',    label: 'Судьи' },
      { path: '/contacts',       icon: 'contacts',  label: 'Контакты' },
      { path: '/my-docs',        icon: 'legal',     label: 'Мои документы' },
      { path: '/remote-clients', icon: 'remote',    label: 'Дист. клиенты' },
    ],
  },
];

const readCollapsed = () => { try { return JSON.parse(localStorage.getItem('sidebar_open') || '{}'); } catch { return {}; } };

const SOURCES = LEAD_SOURCES;

const emptyClient = {
  last_name: '', first_name: '', middle_name: '',
  birth_date: '', phone: '',
  source: '', type: 'unknown',
  consultation_date: new Date().toISOString().split('T')[0],
  consultation_time: '', consultation_status: 'pending',
  referrer_client_id: null, referrer_name: '',
  referral_fee_type: 'cash', referral_fee_amount: '',
  stage: 'consultation',
};

export default function Sidebar({ isOpen, onClose }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useContext(AuthContext);
  const badges = useContext(BadgesContext);
  const [mfcUnread, setMfcUnread] = useState(0);

  React.useEffect(() => {
    let prev = 0;
    const notifySound = () => {
      try {
        const ctx = new (window.AudioContext || window.webkitAudioContext)();
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.connect(gain); gain.connect(ctx.destination);
        osc.frequency.value = 880; gain.gain.value = 0.3;
        osc.start(); osc.stop(ctx.currentTime + 0.15);
      } catch {}
    };
    const fetchMfc = () => api.get("/mfc-clients/chats").then(r => {
      const n = r.data.total_unread || 0;
      if (n > prev && prev !== null) {
        notifySound();
        if (Notification.permission === "granted") {
          new Notification("МФЦ-сервис", { body: "Новое сообщение от клиента", icon: "/favicon.ico" });
        }
      }
      prev = n;
      setMfcUnread(n);
    }).catch(() => {});
    if (Notification.permission === "default") Notification.requestPermission();
    fetchMfc();
    // раз в минуту и только когда вкладка CRM на экране (было каждые 15 с — 14 тыс. запросов за 2 недели)
    const iv = setInterval(() => { if (document.visibilityState === 'visible') fetchMfc(); }, 60000);
    return () => clearInterval(iv);
  }, []);

  React.useEffect(() => {
    const ping = () => fetch("https://mfc.ucfemida.ru/api/support/admin-ping", { method: "POST" }).catch(() => {});
    ping();
    // «юрист на связи» для клиентов сервиса: считаем на связи, только пока CRM открыта на экране
    const iv2 = setInterval(() => { if (document.visibilityState === 'visible') ping(); }, 30000);
    return () => clearInterval(iv2);
  }, []);
  const [openState, setOpenState] = useState(readCollapsed);
  const toggleGroup = (key, current) => {
    const next = { ...openState, [key]: !current };
    setOpenState(next);
    try { localStorage.setItem('sidebar_open', JSON.stringify(next)); } catch {}
  };
  const [showAdd, setShowAdd] = useState(false);
  const [showInquiry, setShowInquiry] = useState(false);
  const [form, setForm] = useState(emptyClient);
  const [saving, setSaving] = useState(false);
  const [allClients, setAllClients] = useState([]);

  const handleLogout = async () => { await api.post('/auth/logout'); setUser(null); };

  const isActive = (path, exact) =>
    exact
      ? location.pathname === path || (path === '/clients' && location.pathname.startsWith('/clients/')) || (path === '/cases' && location.pathname.startsWith('/cases/'))
      : location.pathname.startsWith(path);

  const go = (path) => { navigate(path); if (onClose) onClose(); };

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const openAdd = () => {
    setShowAdd(true);
    api.get('/referrals/clients-list').then(r => setAllClients(r.data)).catch(() => {});
  };

  const [needSource, setNeedSource] = useState(false);
  const closeAdd = () => { setShowAdd(false); setForm(emptyClient); setNeedSource(false); };

  const handleCreate = async () => {
    if (!form.last_name.trim() || !form.first_name.trim()) return;
    if (!form.source) { setNeedSource(true); return; }   // источник обязателен — иначе отчёт «Что приносит деньги» неполный
    setSaving(true);
    try {
      const name = [form.last_name, form.first_name, form.middle_name].filter(Boolean).join(' ');
      const res = await api.post('/clients', { ...form, name });
      closeAdd();
      navigate('/clients/' + res.data.id);
    } catch {}
    setSaving(false);
  };

  return (
    <aside className={`sidebar ${isOpen ? 'open' : ''}`} style={sidebarStyle}>

      {/* Логотип */}
      <div style={logoAreaStyle} onClick={() => go('/')}>
        <div style={logoBadgeStyle}>Ф</div>
        <div>
          <div style={{ fontSize: 14, fontWeight: 700, color: '#1e2a3a', letterSpacing: '-0.01em' }}>Фемида</div>
          <div style={{ fontSize: 11, color: '#8fa0b4', marginTop: 1 }}>Юридический центр</div>
        </div>
      </div>

      {/* Общий поиск: клиент / дело по номеру, ФИО, телефону — с любой страницы */}
      <GlobalSearch onNavigate={() => { if (onClose) onClose(); }} />

      {/* Быстрая кнопка: пустая анкета */}
      <div style={{ padding: '0 12px 10px' }}>
        <button
          onClick={async () => {
            try {
              const r = await api.get('/print-form/anketa', { responseType: 'blob' });
              const today = new Date().toLocaleDateString('ru-RU', { day:'2-digit', month:'2-digit', year:'numeric' });
              const url = window.URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }));
              const a = document.createElement('a'); a.href = url; a.download = 'anketa-' + today + '.pdf';
              a.click(); window.URL.revokeObjectURL(url);
            } catch {}
          }}
          title="Скачать пустую анкету для печати"
          style={{
            width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center',
            gap: 6, padding: '8px 10px', borderRadius: 6, border: '1px solid #e2e8f0',
            background: '#fff', color: '#1e3a8a', fontSize: 12, fontWeight: 600,
            cursor: 'pointer',
          }}
        >📋 Анкета (пустая)</button>
        <button
          onClick={() => setShowInquiry(true)}
          title="Записать звонок/обращение — даже если не взял или передал Александру"
          style={{
            width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center',
            gap: 6, padding: '8px 10px', borderRadius: 6, border: '1px solid #c7d2fe', marginTop: 6,
            background: '#eef2ff', color: '#3730a3', fontSize: 12, fontWeight: 600,
            cursor: 'pointer',
          }}
        >📞 Обращение</button>
      </div>

      {/* Навигация */}
      <nav style={{ flex: 1, overflowY: 'auto', padding: '4px 0 8px' }}>
        {(() => {
          const badgeVal = item => (item.badgeKey === 'mfcUnread' ? mfcUnread : (badges[item.badgeKey] || 0));
          const renderItem = item => {
            const active = isActive(item.path, item.exact);
            const val = item.badgeKey ? badgeVal(item) : 0;
            return (
              <button key={item.path} style={navItemStyle(active)} onClick={() => go(item.path)}>
                <span style={iconWrapStyle(active)}><Icon d={ICONS[item.icon]} size={15} /></span>
                <span style={{ flex: 1, textAlign: 'left' }}>{item.label}</span>
                {val > 0 && <span style={badgeStyle}>{val}</span>}
              </button>
            );
          };
          const renderGroup = group => {
            const hasActive = group.items.some(i => isActive(i.path, i.exact));
            const open = hasActive || (openState[group.key] ?? group.defaultOpen);
            const sum = group.items.reduce((acc, i) => acc + (i.badgeKey ? badgeVal(i) : 0), 0);
            return (
              <div key={group.key}>
                <button style={groupHeaderStyle} onClick={() => toggleGroup(group.key, open)} title={open ? 'Свернуть' : 'Развернуть'}>
                  <span style={{ flex: 1, textAlign: 'left' }}>{group.label}</span>
                  {!open && sum > 0 && <span style={{ ...badgeStyle, marginRight: 6 }}>{sum}</span>}
                  <span style={{ fontSize: 9, transform: open ? 'rotate(90deg)' : 'none', transition: 'transform 0.15s' }}>▶</span>
                </button>
                {open && <div style={groupStyle}>{group.items.map(renderItem)}</div>}
              </div>
            );
          };
          return (
            <>
              {/* Рабочий стол — всегда открыт */}
              <div style={sectionLabelStyle}>{DESK.label}</div>
              <div style={groupStyle}>{DESK.items.map(renderItem)}</div>

              {/* Банкротство */}
              <div style={{ ...sectionLabelStyle, display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingRight: 12 }}>
                <span>Банкротство</span>
                <button onClick={openAdd} title="Добавить клиента" style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  width: 18, height: 18, borderRadius: 4, border: 'none',
                  background: 'rgba(79,110,247,0.1)', color: '#4f6ef7',
                  cursor: 'pointer', fontSize: 14, lineHeight: 1, padding: 0,
                }}>+</button>
              </div>
              <div style={groupStyle}>{CLIENT_MAIN.map(renderItem)}</div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4, padding: '4px 12px 2px' }}>
                {CLIENT_FILTERS.map(f => {
                  const active = isActive(f.path);
                  return (
                    <button key={f.path} onClick={() => go(f.path)} style={chipStyle(active)}>{f.label}</button>
                  );
                })}
              </div>

              {GROUPS.map(renderGroup)}

              <div style={{ marginTop: 10 }}>
                <HabitsWidget open={openState.habits ?? true} onToggleOpen={() => toggleGroup('habits', openState.habits ?? true)} onOpenStats={() => go('/habits')} />
              </div>
            </>
          );
        })()}
      </nav>

      {/* Выйти */}
      <div style={{ padding: '10px 12px', borderTop: '1px solid #e2e8f0' }}>
        <button style={navItemStyle(false)} onClick={handleLogout}>
          <span style={iconWrapStyle(false)}><Icon d={ICONS.logout} size={15} /></span>
          <span>Выйти</span>
        </button>
      </div>

      {showInquiry && <QuickInquiry onClose={() => setShowInquiry(false)} onSaved={() => window.dispatchEvent(new Event('inquiry-saved'))} />}

      {showAdd && (
        <Modal title="Новый клиент" onClose={closeAdd}
          footer={
            <>
              <button className="btn btn-secondary" onClick={closeAdd}>Отмена</button>
              <button className="btn btn-primary" onClick={handleCreate} disabled={saving || !form.last_name || !form.first_name}>
                {saving ? 'Сохранение...' : 'Создать'}
              </button>
            </>
          }
        >
          <input className="form-input" style={{marginBottom:6}} placeholder="Фамилия *" autoFocus value={form.last_name} onChange={e => set('last_name', e.target.value)} />
          <input className="form-input" style={{marginBottom:6}} placeholder="Имя *" value={form.first_name} onChange={e => set('first_name', e.target.value)} />
          <input className="form-input" style={{marginBottom:6}} placeholder="Отчество" value={form.middle_name} onChange={e => set('middle_name', e.target.value)} />
          <input className="form-input" style={{marginBottom:6}} type="date" value={form.birth_date} onChange={e => set('birth_date', e.target.value)} />
          <input className="form-input" style={{marginBottom:6}} placeholder="Телефон" value={form.phone} onChange={e => set('phone', e.target.value)} />
          <select className="form-select" style={{marginBottom:6, borderColor: needSource && !form.source ? '#ef4444' : undefined}} value={form.source} onChange={e => { set('source', e.target.value); setNeedSource(false); }}>
            <option value="">Откуда узнали... *</option>
            {SOURCES.map(s => <option key={s}>{s}</option>)}
          </select>
          {needSource && !form.source && <div style={{fontSize:11,color:'#ef4444',margin:'-2px 0 6px'}}>Укажите, откуда человек о нас узнал. Не знаете — «Другое».</div>}
          {form.source === 'Рекомендация' && (
            <>
              <select className="form-select" style={{marginBottom:6}} value={form.referrer_client_id || ''} onChange={e => set('referrer_client_id', e.target.value ? Number(e.target.value) : null)}>
                <option value="">— выбрать клиента —</option>
                {allClients.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
              {!form.referrer_client_id && (
                <input className="form-input" style={{marginBottom:6}} value={form.referrer_name} onChange={e => set('referrer_name', e.target.value)} placeholder="или ФИО вручную" />
              )}
              {(form.referrer_client_id || form.referrer_name) && (
                <div style={{display:'flex', gap:6, marginBottom:6}}>
                  <select className="form-select" value={form.referral_fee_type} onChange={e => set('referral_fee_type', e.target.value)}>
                    <option value="cash">Деньгами</option>
                    <option value="discount">Скидка клиенту</option>
                  </select>
                  <input className="form-input" type="number" value={form.referral_fee_amount} onChange={e => set('referral_fee_amount', e.target.value)} placeholder={form.type === 'court' ? '10000' : '5000'} />
                </div>
              )}
            </>
          )}
          <select className="form-select" style={{marginBottom:6}} value={form.type} onChange={e => set('type', e.target.value)}>
            <option value="unknown">Не определено</option>
            <option value="mfc">Внесудебное (МФЦ)</option>
            <option value="court">Судебное</option>
          </select>
          <div style={{display:'flex', gap:6, marginBottom:6}}>
            <input className="form-input" style={{flex:2}} type="date" value={form.consultation_date} onChange={e => set('consultation_date', e.target.value)} />
            <input className="form-input" style={{flex:1}} type="time" value={form.consultation_time} onChange={e => set('consultation_time', e.target.value)} />
          </div>
          <select className="form-select" value={form.consultation_status} onChange={e => set('consultation_status', e.target.value)}>
            <option value="pending">Консультация запланирована</option>
            <option value="client">Стал клиентом</option>
            <option value="thinking">Думает</option>
            <option value="analysis">Анализ юриста</option>
            <option value="rejected">Не стал клиентом</option>
          </select>
        </Modal>
      )}
    </aside>
  );
}

const sidebarStyle = {
  width: 232,
  background: '#ffffff',
  display: 'flex',
  flexDirection: 'column',
  position: 'fixed',
  top: 0, left: 0, bottom: 0,
  zIndex: 100,
  transition: 'transform 0.25s ease',
  borderRight: '1px solid #e2e8f0',
  boxShadow: '2px 0 12px rgba(30,42,58,0.05)',
};

const logoAreaStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  padding: '18px 16px 16px',
  cursor: 'pointer',
  borderBottom: '1px solid #e2e8f0',
  marginBottom: 4,
};

const logoBadgeStyle = {
  width: 32,
  height: 32,
  borderRadius: 8,
  background: 'linear-gradient(135deg, #4f6ef7, #3b5be0)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 15,
  fontWeight: 700,
  color: '#fff',
  flexShrink: 0,
  boxShadow: '0 2px 8px rgba(79,110,247,0.3)',
};

const groupHeaderStyle = {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  fontSize: 10,
  fontWeight: 600,
  letterSpacing: '0.07em',
  textTransform: 'uppercase',
  color: '#8fa0b4',
  padding: '12px 16px 4px',
  border: 'none',
  background: 'transparent',
  cursor: 'pointer',
  fontFamily: 'inherit',
  userSelect: 'none',
};

const chipStyle = (active) => ({
  padding: '4px 6px',
  borderRadius: 6,
  border: `1px solid ${active ? '#4f6ef7' : '#e2e8f0'}`,
  background: active ? 'rgba(79,110,247,0.08)' : '#fff',
  color: active ? '#4f6ef7' : '#4a5568',
  fontSize: 11.5,
  fontWeight: active ? 600 : 400,
  cursor: 'pointer',
  fontFamily: 'inherit',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

const sectionLabelStyle = {
  fontSize: 10,
  fontWeight: 600,
  letterSpacing: '0.07em',
  textTransform: 'uppercase',
  color: '#8fa0b4',
  padding: '12px 16px 4px',
  userSelect: 'none',
};

const groupStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  padding: '0 8px',
};

const navItemStyle = (active) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  padding: '7px 10px',
  borderRadius: 7,
  border: 'none',
  background: active ? 'rgba(79,110,247,0.08)' : 'transparent',
  color: active ? '#4f6ef7' : '#4a5568',
  fontSize: 13,
  fontWeight: active ? 600 : 400,
  cursor: 'pointer',
  width: '100%',
  textAlign: 'left',
  fontFamily: 'inherit',
  transition: 'all 0.12s ease',
  letterSpacing: '-0.01em',
});

const iconWrapStyle = (active) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 20,
  height: 20,
  color: active ? '#4f6ef7' : '#8fa0b4',
  flexShrink: 0,
});

const badgeStyle = {
  marginLeft: 'auto',
  background: '#ef4444',
  color: '#fff',
  borderRadius: 10,
  padding: '1px 6px',
  fontSize: 11,
  fontWeight: 700,
  minWidth: 18,
  textAlign: 'center',
};
